// Snapshot of the Aulas AI generation screen, taken when the teacher moves on to
// /create-test. Going back from there restores it so the generated questions are
// not lost. In memory only: a full page reload starts fresh. Cleared once the
// test is created or the create flow is cancelled.
let snapshot = null;

export const saveGenerationSnapshot = (value) => {
  snapshot = value;
};

export const getGenerationSnapshot = () => snapshot;

export const clearGenerationSnapshot = () => {
  snapshot = null;
};
